import { useEffect, useState } from 'react';
import { getTeamPermissions } from '../api/teamPermissions';
/**
 * Returns all teams that are assigned to @objectIdOrIds via marketing/asset-permissions/v1/teams service.
 * In case @objectIdOrIds has more than one object id, the API call won't run and the hook will return an empty array of team ids.
 */
export default function useFetchTeamPermissions({
  objectType,
  objectIdOrIds
}) {
  const [state, setState] = useState({
    loading: true,
    teamIds: [],
    error: undefined
  });
  useEffect(() => {
    /**
     * Does not fetch permissions when @objectIdOrIds is empty or if @objectIdOrIds has more than 1 element.
     */
    if (!objectIdOrIds || Array.isArray(objectIdOrIds) && objectIdOrIds.length !== 1) {
      setState({
        loading: false,
        teamIds: [],
        error: undefined
      });
      return;
    }

    // Fetch team permissions for a single objectId
    const objectId = Array.isArray(objectIdOrIds) ? objectIdOrIds[0] : objectIdOrIds;
    setState({
      loading: true,
      teamIds: [],
      error: undefined
    });
    getTeamPermissions({
      objectType,
      objectId
    }).then(teamIds => setState({
      loading: false,
      teamIds,
      error: undefined
    })).catch(error => setState({
      loading: false,
      teamIds: [],
      error
    }));
  }, [objectIdOrIds, objectType]);
  return state;
}